<template>
  <model-form
    ref="modelForm"
    :model="paymentConnectorTransactionNumber"
    modal-type="modal"
    width="600px;"
    @on-show="onShow"
  >
    <div class="row q-col-gutter-md">
      <q-input
        v-model.trim="paymentConnectorTransactionNumber.startId"
        class="col-6"
        label="Transaction Start Number"
        :rules="[val => !!val && paymentConnectorTransactionNumber.startId < paymentConnectorTransactionNumber.endId || 'Field is required']"
      />
      <q-input
        v-model.trim="paymentConnectorTransactionNumber.endId"
        class="col-6"
        label="Transaction End Number"
        :rules="[val => !!val && paymentConnectorTransactionNumber.endId > paymentConnectorTransactionNumber.startId || 'Field is required']"
      />
    </div>
    <div class="row q-col-gutter-md">
      <iso-date-input
        v-model="paymentConnectorTransactionNumber.startDate"
        emit-string="nullify-blank"
        class="col-6"
        label="Effective From"
        clearable
        :rules="[
          val => val !== null || 'Field is required',
          () => !paymentConnectorTransactionNumber.endDate || paymentConnectorTransactionNumber.startDate < paymentConnectorTransactionNumber.endDate || 'Must be prior to effective from date',
        ]"
      />

      <iso-date-input
        v-model="paymentConnectorTransactionNumber.endDate"
        emit-string="nullify-blank"
        class="col-6"
        label="Effective To"
        clearable
        :rules="[
          val => val !== null || 'Field is required',
          () => !paymentConnectorTransactionNumber.startDate || paymentConnectorTransactionNumber.endDate > paymentConnectorTransactionNumber.startDate || 'Must predate effective to date',
        ]"
      />
    </div>
  </model-form>
</template>

<script>

import PaymentConnectorConfiguration from 'src/models/payment-connector/PaymentConnectorConfiguration'
import IsoDateInput from 'src/modules/admin/components/IsoDateInput'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'PaymentConnectorConfigurationForm',
  components: {
    ModelForm,
    IsoDateInput
  },
  props: {
    paymentConnectorConfiguration: {
      type: PaymentConnectorConfiguration,
      required: true
    }
  },
  models: {
    paymentConnectorTransactionNumber: true
  },
  watch: {
    paymentConnectorTransactionNumber () {
      this.paymentConnectorTransactionNumber.paymentConnectorConfiguration = this.paymentConnectorConfiguration
    }
  },
  methods: {
    onShow () {
      this.paymentConnectorTransactionNumber.paymentConnectorConfiguration = this.paymentConnectorConfiguration
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
